const authActions = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",

  login: data => {
    return {
      type: authActions.LOGIN,
      isLogin: true,
      accessToken: data.token,
      adminType: data.adminType || null,
      storesId: data.storesId || null,
      storeName: data.storeName || null,
      storeLogo: data.storeLogo || null,
      primaryColor: data.primaryColor || null,
      secondaryColor: data.secondaryColor || null,
      sidebarColor: data.sidebarColor || null,
      topbarColor: data.topbarColor || null,
      menuHighlightColor: data.menuHighlightColor || null,
      menuTextColor: data.menuTextColor || null,
      accentColor: data.accentColor || null
    };
  },
  /** Plain reducer action — prefer `logoutAndClearSession` for app logout / 401. */
  logout: () => {
    return {
      type: authActions.LOGOUT,
      isLogin: false,
      accessToken: null
    };
  }
};

export default authActions;
